import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { TextField } from "@mui/material";
import { DevicesContext } from "../../data/devices/DevicesContext";
import { useValidations } from "../../data/ValidationContext";

const DevicesUpdateModal = ({ isOpen, onClose, deviceId }) => {
  const { devicesList, updateDevice } = useContext(DevicesContext);
  const device = devicesList.find((d) => d.id === deviceId);
    const { vs_device } = useValidations(); 
  if (!device) return null;

  const initialValues = {
    brand: device.brand,
    model: device.model,
    description: device.description,
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={vs_device}
        onSubmit={(values) => {
          const isDuplicate = devicesList.some(
            (d) =>
              d.id !== deviceId &&
              d.brand.toLowerCase() === values.brand.toLowerCase() &&
              d.model.toLowerCase() === values.model.toLowerCase()
          );
          if (isDuplicate) {
            alert("Bu cihaz zaten mevcut!");
            return;
          }

          updateDevice(deviceId, values);
          onClose();
        }}
      >
        {({ values, errors, touched, handleChange }) => (
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Cihaz Güncelle</Modal.Title>
            </Modal.Header>

            <Modal.Body className="d-flex flex-col gap-3">
              <TextField
                label="Marka"
                name="brand"
                value={values.brand}
                onChange={handleChange}
                fullWidth
                size="small"
                error={touched.brand && !!errors.brand}
                helperText={touched.brand && errors.brand}
              />

              <TextField
                label="Model"
                name="model"
                value={values.model}
                onChange={handleChange}
                fullWidth
                size="small"
                error={touched.model && !!errors.model}
                helperText={touched.model && errors.model}
              />

              <TextField
                label="Açıklama"
                name="description"
                value={values.description}
                onChange={handleChange}
                fullWidth
                size="small"
                multiline
                minRows={2}
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
              />
            </Modal.Body>

            <Modal.Footer>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Güncelle
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DevicesUpdateModal;
